import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-mobx-router5';
import { Alert } from '@patternfly/react-core';

const OfferingsListV2ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className="dashboard-offerings-v2-error">
      <Alert variant="warning" title={t('Progress table unavailable')} isInline>
        <p>
          {t(
            'We are having trouble loading your offerings. You can explore the catalog while we fix this.',
          )}
        </p>
        <Link href routeName="catalog">
          {t('Explore the Catalog')}
        </Link>
      </Alert>
    </div>
  );
};

export default OfferingsListV2ErrorFallback;
